export const GOOGLE_MAPS_API_KEY = "AIzaSyBkgLjIcwKCCbNaG_habGNw4GQFkQKwjiw";